import { render, staticRenderFns } from "./ColorSwatches.vue?vue&type=template&id=73574464&scoped=true"
import script from "./ColorSwatches.vue?vue&type=script&lang=js"
export * from "./ColorSwatches.vue?vue&type=script&lang=js"
import style0 from "./ColorSwatches.vue?vue&type=style&index=0&id=73574464&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73574464",
  null
  
)

export default component.exports